import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Floor11K5() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

  useEffect(() => {
    let stopTimeout;
    const startTimeout = setTimeout(() => {
      setIsHovered(true); // Show the image and tooltip briefly

      stopTimeout = setTimeout(() => {
        setIsHovered(false); // Then hide it
      }, 300); // Duration of animation
    }, 500); // Delay before animation starts

    return () => {
      clearTimeout(startTimeout);
      if (stopTimeout) clearTimeout(stopTimeout);
    };
  }, []);


  // Detect screen size for mobile behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle clicks outside the image (to remove hover effect on mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true); // First tap activates hover
        setIsClicked(true);
      } else {
        navigate("/eleventh-floor"); // Second tap navigates
      }
    } else {
      navigate("/eleventh-floor"); // Direct navigation on desktop
    }
  };

  return (
    <>
      {/* Green Overlay (Shown on Hover or Click for Mobile) */}
      <img
        ref={imageRef}
        className={`absolute w-[33.85vw] left-[23.5vw] top-[7.58vw] cursor-pointer transition-opacity duration-300 ${
          isHovered ? "opacity-100" : "opacity-0"
        }`}
        src="/images/click/clickable-images/Floors/Floor11-K5-Green.png"
        alt="Eleventh Floor"
        onMouseEnter={() => !isMobile && setIsHovered(true)} // Desktop hover effect
        onMouseLeave={() => !isMobile && setIsHovered(false)} // Remove hover effect on desktop
        onClick={handleClick} // Click-to-hover for mobile
      />

      {/* Tooltip on Hover or Click (for Mobile) */}
      {isHovered && (
        <span className="absolute left-[57.5vw] top-[9vw] bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 shadow-md">
          Kati 11
        </span>
      )}
    </>
  );
}

export default Floor11K5;
